var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"items":_vm.data,"fields":_vm.fields},scopedSlots:_vm._u([{key:"head(reportedDate)",fn:function(){return [_c('div',{staticClass:"text-nowrap"},[_vm._v("Reported Date")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }